export default __webpack_public_path__ + "static/ultraballsleep-15553f594021b28994b3dabec80fa3f1.png";